import { EMPRESA } from "../marca";

/* El bloque de marca de las pantallas de afuera: login, crear clave, cambiar
 * contraseña.
 *
 * Existe porque estaba copiado en las tres, y copiado tres veces es como el
 * nombre viejo sobrevivió a dos renombres: se cambia en una, se olvidan las
 * otras, y la app termina llamándose de dos formas según por dónde entres.
 *
 * El nombre va partido —Fi + BOT— porque el CSS pinta el <span> de ámbar. Esa
 * partición es la regla de mayúsculas dicha por el diseño en vez de por una
 * convención que hay que acordarse de respetar.
 */
const Marca = () => (
  <div className="login-screen__brand">
    <h1 className="login-screen__title">
      Fi<span>BOT</span>
    </h1>
    <p className="login-screen__tagline">Gestión de flotas — {EMPRESA}</p>
  </div>
);

export default Marca;
